import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import ru from '../public/locales/ru/common.json'
import en from '../public/locales/en/common.json'
import kz from '../public/locales/kz/common.json'

const resources = {
  ru: {
    translation: ru
  },
  en: {
    translation: en
  },
  kz: {
    translation: kz
  }
}

const SUPPORTED_LANGS = ['ru', 'en', 'kz']
const STORAGE_KEY = 'i18nextLng'

const resolveInitialLanguage = () => {
  if (typeof window === 'undefined') return 'ru'

  const fromStorage = window.localStorage.getItem(STORAGE_KEY)
  if (fromStorage && SUPPORTED_LANGS.includes(fromStorage)) {
    return fromStorage
  }

  const browserLang = window.navigator?.language?.split('-')?.[0]
  if (browserLang && SUPPORTED_LANGS.includes(browserLang)) {
    return browserLang
  }

  return 'ru'
}

const initialLanguage = resolveInitialLanguage()

if (typeof window !== 'undefined') {
  window.localStorage.setItem(STORAGE_KEY, initialLanguage)
}

void i18n
  .use(initReactI18next)
  .init({
    resources,
    debug: import.meta.env.DEV,
    supportedLngs: SUPPORTED_LANGS,
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    lng: initialLanguage,
    fallbackLng: 'ru',
    keySeparator: false,
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false
    }
  })

export default i18n
